import { Dayjs } from "dayjs";

export const formatDate = (dateString: string) => {
  const date = new Date(dateString);
  return date.toISOString().split('T')[0].replace(/-/g, '.');
};

export const formatDateForApi = (date: Dayjs | null): string => {
  return date ? date.format('YYYY-MM-DD') : '';
};